/**
 * ============================================================================
 * ENTRY POINT - React Application
 * ============================================================================
 */

/* Force dark mode from first paint (no flash of light) */
document.documentElement.setAttribute('data-theme', 'dark');
document.documentElement.classList.add('dark');

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from './providers';
import App from './App';
import { registerServiceWorker } from './utils/serviceWorker';
/* Order: Tailwind first, then design system so our styles apply */
import './index.css';
import './styles/global.css';
import './styles/animations.css';
import './styles/public-layout.css';
import './styles/auth.css';
import './styles/public-page.css';

// Initialize error tracking (Sentry, etc.)
if (import.meta.env.VITE_SENTRY_DSN) {
  // Initialize Sentry if DSN is provided
  // import * as Sentry from '@sentry/react';
  // Sentry.init({ dsn: import.meta.env.VITE_SENTRY_DSN });
}

// Analytics configuration
const analyticsConfig = {
  googleAnalyticsId: import.meta.env.VITE_GA_ID,
  mixpanelToken: import.meta.env.VITE_MIXPANEL_TOKEN,
  posthogKey: import.meta.env.VITE_POSTHOG_KEY,
  posthogHost: import.meta.env.VITE_POSTHOG_HOST,
};

// App configuration
const appConfig = {
  defaultLocale: import.meta.env.VITE_DEFAULT_LOCALE || 'en',
  analytics: analyticsConfig,
};

// Render app
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppProvider config={appConfig}>
        <App />
      </AppProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// Register service worker for PWA
if (import.meta.env.PROD) {
  registerServiceWorker();
}
